import { SendToMobile } from '@mui/icons-material';
import { Grid, Alert, lighten, Button, Typography, Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared/components/styles/colors';
import { GroupMessageResponse } from '../models/groupMessageResponse';
import { GroupMessageEmailStatusModal } from './groupMessageEmailStatusModal';

type GroupMessageEmailStatusMessageProps = {
  callback: () => void;
  groupMessageEmailResponse: GroupMessageResponse;
};

export const GroupMessageEmailStatusMessage = (props: GroupMessageEmailStatusMessageProps) => {
  const { callback, groupMessageEmailResponse } = props;
  const { t } = useTranslation(['groupMessage']);

  const [showSmsStatusModal, setShowSmsStatusModal] = useState<boolean>(false);

  const handleSmsStatus = () => {
    setShowSmsStatusModal(false);
    callback();
  };

  return (
    <Grid item xs={12}>
      <Alert
        severity='info'
        variant='outlined'
        icon={false}
        sx={{ backgroundColor: lighten(Colors.ChipColors.Blue, 0.9), '& .MuiAlert-message': { width: '100%' } }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
          <Typography variant='body1' sx={{ m: 0 }}>
            <strong>{t('groupMessage:sms.sent')}</strong> {groupMessageEmailResponse?.sendDate}
          </Typography>
          {groupMessageEmailResponse?.circulars.length > 0 && (
            <Button variant='contained' size='large' startIcon={<SendToMobile />} disableElevation onClick={() => setShowSmsStatusModal(true)}>
              {t('groupMessage:sms.deliveryStatus')}
            </Button>
          )}
        </Box>
      </Alert>
      {showSmsStatusModal && (
        <GroupMessageEmailStatusModal
          modalOpen={showSmsStatusModal}
          groupMessageEmailResponse={groupMessageEmailResponse}
          onSave={() => handleSmsStatus()}
          onClose={() => handleSmsStatus()}
        />
      )}
    </Grid>
  );
};
